import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import media from '../../../../services/generateMediaQueries'

const Control = styled.input`
  outline: 0;
  width: 100%;
  height: 100%;
  font-size: 24px;
  position: relative;
  background-color: transparent;
  transition-property: border-color, opacity;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);
  border: none;
  border-bottom: 1px #cccccc solid;
  font-weight: ${({ bold }) =>
    bold ? 'var(--font-weight-' + bold + ')' : 'var(--font-weight)'};
  color: ${({ color }) => {
    switch (color) {
      case 'primary':
        return 'var(--color-primary)'
      case 'secondary':
        return 'var(--color-secondary)'
      case 'tertiary':
        return 'var(--color-tertiary)'
      default:
        return color
    }
  }} !important;

  ${props =>
    props.hasError &&
    css`
      border-color: var(--color-error);
    `}

  &:disabled {
    opacity: 0.5;
  }

  &::placeholder {
    color: var(--color-fg-light);
    opacity: 0.6;
  }

  &::-webkit-autofill,
  &::-webkit-autofill:hover,
  &::-webkit-autofill:focus,
  &::-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    font-size: 24px;
    color: ${({ color }) => {
      switch (color) {
        case 'primary':
          return 'var(--color-primary)'
        case 'secondary':
          return 'var(--color-secondary)'
        case 'tertiary':
          return 'var(--color-tertiary)'
        default:
          return color
      }
    }} !important;
  }

  &:-internal-autofill-selected {
    color: ${({ color }) => {
      switch (color) {
        case 'primary':
          return 'var(--color-primary)'
        case 'secondary':
          return 'var(--color-secondary)'
        case 'tertiary':
          return 'var(--color-tertiary)'
        default:
          return color
      }
    }} !important;
  }
`
const Label = styled.span`
  opacity: 0.8;
  color: ${({ hasError }) =>
    hasError ? 'var(--color-error)' : 'var(--color-fg)'};
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  letter-spacing: 0px;
  text-align: left;
`
const ControlBase = styled.label`
  position: relative;
  display: block;
  width: 100%;
  height: 3.25rem;
  padding-top: 0.5rem;
`
const ComponentBase = styled.div`
  ${media.greaterThan(`small`)`
  margin-bottom: 0.625rem;
  `}
`
const InfoMessage = styled.output`
  display: block;
  color: ${({ hasError }) =>
    hasError ? 'var(--color-error)' : 'var(--color-fg)'};
  font-size: 0.75em;
  margin-top: 1.75rem;
  overflow: hidden;
  height: 1.125rem;
  transition-property: height, opacity;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);

  :empty {
    height: 0;
    opacity: 0;
  }

  ${ControlBase}:focus-within ~ & {
    ${({ hasError }) =>
      hasError &&
      `
      height: 0;
      opacity: 0;
    `}
  }
`

class TextInput extends React.Component {
  input = React.createRef()

  componentDidMount() {
    const { initialValue } = this.props

    if (this.input.current) {
      this.input.current.value = initialValue
    }
  }

  componentDidUpdate(prevProps) {
    const { initialValue } = this.props

    if (prevProps.initialValue !== initialValue) {
      this.input.current.value = initialValue
    }
  }

  render() {
    const {
      type,
      bold,
      info,
      error,
      label,
      touched,
      variant,
      centered,
      iconName,
      iconColor,
      onIconClick,
      placeholder,
      floatingLabel,
      valueColor = '#000',
      ...props
    } = this.props

    const iconProps = {}

    if (onIconClick) {
      iconProps.onClick = onIconClick
    }

    return (
      <ComponentBase>
        <ControlBase>
          <Label hasError={touched && error}>{label}</Label>
          <Control
            {...props}
            type={type}
            bold={bold}
            ref={this.input}
            color={valueColor}
            placeholder={placeholder}
            hasError={touched && error}
          />
        </ControlBase>
        <InfoMessage hasError={touched && error}>
          {(touched && error) || info}
        </InfoMessage>
      </ComponentBase>
    )
  }
}

TextInput.defaultProps = {
  placeholder: '',
  initialValue: '',
  error: null,
  touched: false,
  floatingLabel: true,
  centered: false,
}

TextInput.propTypes = {
  placeholder: PropTypes.string,
  initialValue: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
  floatingLabel: PropTypes.bool,
  centered: PropTypes.bool,
}

export default TextInput
